import React from 'react';
import { connect } from 'react-redux'
import { Utils } from '../../utilSMB/utils';

class ProductColor extends React.PureComponent {
    render() {
        let colorList = [];
        let selectedColor = '';
        let styleColor = [];
        let textColor = 'text-white';
        let lytColor = [];
        let darkColor = [];
        let prodcolor
        this.props.itemValue.map((itemValue, index) => {
            if(itemValue.color){
                prodcolor=itemValue.color.replace(/\s/g, '')
                }
                else{
                 prodcolor=itemValue.color
                }
            if (this.props.itemValue.length === 1) {
                if (Utils.isNotNull(itemValue.color)) {
                    var color = itemValue.color
                    lytColor = ['Chalk', 'Lilac', 'Slate', 'White']
                    darkColor = ['Charcoal', 'Black', 'Blue', 'Gray', 'Grey', 'Silver']
                    lytColor.map((colorLyt, index) => {
                        if (colorLyt === color) {
                            textColor = ".bg-white"
                        }
                        return "";
                    })
                    darkColor.map((colorDark, index) => {
                        if (colorDark === color) {
                            textColor = "text-white"
                        }
                        return "";
                    })
                    selectedColor = ("product-color bg-" + prodcolor.toLowerCase() + " active " + textColor)
                    styleColor = itemValue.color;
                }
            }
            else if (this.props.itemValue.length > 1) {
                let count = 0
                if (Utils.isNotNull(itemValue.color)) {
                    let prodColor = itemValue.color
                    lytColor = ['Chalk', 'Lilac', 'Slate', 'White']
                    darkColor = ['Charcoal', 'Black', 'Blue', 'Gray', 'Grey', 'Silver']
                    lytColor.map((colorLyt, index) => {
                        if (colorLyt === prodColor) {
                            textColor = ".bg-white"
                        }
                        return "";
                    })
                    darkColor.map((colorDark, index) => {
                        if (colorDark === prodColor) {
                            textColor = "text-white"
                        }
                        return "";
                    })
                    if (this.props.productColor.length !== 0 && this.props.fltFlag === true) {
                        this.props.productColor.map((prdClr, index) => {
                            if (count === 0) {
                                selectedColor = (prdClr === itemValue.color  ? ("product-color bg-" + prodcolor.toLowerCase() + " active " + textColor) : ("product-color bg-" + prodcolor.toLowerCase() + " " + textColor))
                                styleColor = itemValue.color;
                                if (prdClr === itemValue.color) {
                                    count = count + 1
                                    { this.props.colorSelection(this.props.groupId, itemValue.productId, true) }
                                }
                            }

                        })
                    }
                    else {
                        selectedColor = (this.props.selectedValue.productId === itemValue.productId ? ("product-color bg-" + itemValue.color.toLowerCase() + " active " + textColor) : ("product-color bg-" + itemValue.color.toLowerCase() + " " + textColor))
                        styleColor = itemValue.color;
                    }
                }
            }
            if (Utils.isNotNull(selectedColor) && selectedColor !== "") {
                colorList.push(
                    <span onClick={(e)=>{e.stopPropagation();}}>
                        <button className={selectedColor} id="prod670040_sku830084_sku830084" style={{ backgroundColor: styleColor }} title={styleColor} onClick={(e) => { this.props.colorSelection(this.props.groupId, itemValue.productId, false) }}></button> &nbsp;
                    </span>

                )
            }
            return "";
        })

        return (
            <React.Fragment>
                {colorList}
            </React.Fragment>
        );
    }
}

export default (connect()(ProductColor));
